import React from 'react';
import { Modal } from 'common/components/Modal';
import { ConfirmationModalProps } from './ConfirmationModal.types';

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
    isOpen,
    title,
    message,
    onConfirm,
    onCancel,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
}) => {
    const handleConfirm = () => {
        onConfirm();
        onCancel();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onCancel}
            title={title}
            size='sm'
            onDone={handleConfirm}
            onCancel={onCancel}
            doneText={confirmText}
            cancelText={cancelText}
        >
            {message}
        </Modal>
    );
};
